import { Component } from '@angular/core';
import { Button } from '../button/button';
import { CalendlyService } from '../../services/calendly.service';

@Component({
  selector: 'app-connect',
  imports: [Button],
  templateUrl: './connect.html',
  styleUrl: './connect.scss'
})
export class Connect {
  constructor(private calendly: CalendlyService) { }

  scheduleCall() {
    this.calendly.openPopup().catch(() => { });
  }
}
